import fetch from './handler'

export const getDashboardDetails = (params) => {
    return fetch({
        url: '/dashboard',
        method: 'GET',
        params
    })
}